// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ausschuesse-page {
  padding-bottom: 40px;
}

.ausschuesse-error {
  background-color: var(--blutorange);
  color: white;
  border-radius: 10px;
  padding: 10px 16px;
  margin-bottom: 12px;
}

.ausschuesse-success {
  background-color: var(--dunkelgruen);
  color: white;
  border-radius: 10px;
  padding: 10px 16px;
  margin-bottom: 12px;
}

/* Zuordnen-Bereich — visuell hervorgehoben */
.ausschuesse-hinzufuegen {
  background-color: var(--gelb);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  border-left: 5px solid var(--orange);
}

.ausschuesse-hinzufuegen label {
  color: white;
}

.ausschuesse-hinzufuegen .dropdown-wrapper select {
  background-color: rgba(255, 255, 255, 0.3);
  color: var(--dunkelgruen);
}

.ausschuesse-hinzufuegen button {
  margin-top: 10px;
  background-color: var(--dunkelgruen);
  color: white;
  width: auto;
  display: inline-block;
  padding: 10px 24px;
}

.ausschuesse-hinzufuegen button:hover {
  opacity: 0.85;
}

/* Ausschuss-Karten */
.ausschuesse-liste {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
}

.ausschuss-card,
.ausschuss-detail {
  background-color: var(--hellgruen);
  border-radius: 12px;
  padding: 16px;
  border-left: 5px solid var(--gelb);
}

/* Klickbare Karten in der Übersicht */
.ausschuss-card-clickable {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.ausschuss-card-clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.ausschuss-card-clickable:active {
  transform: translateY(0);
}

/* Detailansicht */
.ausschuss-detail {
  margin-top: 8px;
}

/* Zurück-Button zur Übersicht */
.btn-back-ausschuss {
  background-color: transparent;
  color: var(--dunkelgruen);
  border: none;
  padding: 4px 0;
  width: auto;
  min-height: auto;
  margin-top: 0;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 0.95em;
}

.btn-back-ausschuss .material-symbols-outlined {
  font-size: 1.2em;
  color: var(--dunkelgruen);
}

.btn-back-ausschuss:hover {
  opacity: 0.7;
}

.ausschuss-titel {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.2em;
  color: var(--dunkelgruen);
  margin-bottom: 12px;
  flex-wrap: wrap;
  text-align: left;
}

.ausschuss-titel .material-symbols-outlined {
  font-size: 1.3em;
  color: var(--gelb);
}

.ausschuss-anzahl {
  margin-left: auto;
  font-size: 0.8em;
  background-color: var(--mittelgruen);
  color: var(--dunkelgruen);
  border-radius: 20px;
  padding: 2px 10px;
}

.ausschuss-leer {
  color: var(--placeholder);
  font-family: 'Circular', sans-serif;
  font-size: 0.9em;
  text-align: left;
}

/* Mitgliederliste */
.ausschuss-mitglieder {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ausschuss-mitglied {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: var(--mittelgruen);
  border-radius: 8px;
  padding: 10px 12px;
}

.mitglied-name {
  flex: 1 1;
  font-size: 1em;
  color: var(--dunkelgruen);
  text-align: left;
}

.mitglied-zelt {
  font-size: 0.85em;
  color: var(--placeholder);
  font-family: 'Circular', sans-serif;
  white-space: nowrap;
}

/* Entfernen-Button — kompakt, gegen globale Button-Regeln abgesichert */
.btn-remove {
  background-color: transparent;
  color: var(--blutorange);
  border: none;
  padding: 4px;
  width: auto;
  min-height: auto;
  margin-top: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.btn-remove .material-symbols-outlined {
  font-size: 1.2em;
  color: var(--blutorange);
}

.btn-remove:hover {
  opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/components/parlament/ausschuesse/Ausschuesse.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,kCAAkC;AACpC;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd","sourcesContent":[".ausschuesse-page {\n  padding-bottom: 40px;\n}\n\n.ausschuesse-error {\n  background-color: var(--blutorange);\n  color: white;\n  border-radius: 10px;\n  padding: 10px 16px;\n  margin-bottom: 12px;\n}\n\n.ausschuesse-success {\n  background-color: var(--dunkelgruen);\n  color: white;\n  border-radius: 10px;\n  padding: 10px 16px;\n  margin-bottom: 12px;\n}\n\n/* Zuordnen-Bereich — visuell hervorgehoben */\n.ausschuesse-hinzufuegen {\n  background-color: var(--gelb);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 20px;\n  border-left: 5px solid var(--orange);\n}\n\n.ausschuesse-hinzufuegen label {\n  color: white;\n}\n\n.ausschuesse-hinzufuegen .dropdown-wrapper select {\n  background-color: rgba(255, 255, 255, 0.3);\n  color: var(--dunkelgruen);\n}\n\n.ausschuesse-hinzufuegen button {\n  margin-top: 10px;\n  background-color: var(--dunkelgruen);\n  color: white;\n  width: auto;\n  display: inline-block;\n  padding: 10px 24px;\n}\n\n.ausschuesse-hinzufuegen button:hover {\n  opacity: 0.85;\n}\n\n/* Ausschuss-Karten */\n.ausschuesse-liste {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 8px;\n}\n\n.ausschuss-card,\n.ausschuss-detail {\n  background-color: var(--hellgruen);\n  border-radius: 12px;\n  padding: 16px;\n  border-left: 5px solid var(--gelb);\n}\n\n/* Klickbare Karten in der Übersicht */\n.ausschuss-card-clickable {\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.ausschuss-card-clickable:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.ausschuss-card-clickable:active {\n  transform: translateY(0);\n}\n\n/* Detailansicht */\n.ausschuss-detail {\n  margin-top: 8px;\n}\n\n/* Zurück-Button zur Übersicht */\n.btn-back-ausschuss {\n  background-color: transparent;\n  color: var(--dunkelgruen);\n  border: none;\n  padding: 4px 0;\n  width: auto;\n  min-height: auto;\n  margin-top: 0;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  font-size: 0.95em;\n}\n\n.btn-back-ausschuss .material-symbols-outlined {\n  font-size: 1.2em;\n  color: var(--dunkelgruen);\n}\n\n.btn-back-ausschuss:hover {\n  opacity: 0.7;\n}\n\n.ausschuss-titel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1.2em;\n  color: var(--dunkelgruen);\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n  text-align: left;\n}\n\n.ausschuss-titel .material-symbols-outlined {\n  font-size: 1.3em;\n  color: var(--gelb);\n}\n\n.ausschuss-anzahl {\n  margin-left: auto;\n  font-size: 0.8em;\n  background-color: var(--mittelgruen);\n  color: var(--dunkelgruen);\n  border-radius: 20px;\n  padding: 2px 10px;\n}\n\n.ausschuss-leer {\n  color: var(--placeholder);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.9em;\n  text-align: left;\n}\n\n/* Mitgliederliste */\n.ausschuss-mitglieder {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ausschuss-mitglied {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: var(--mittelgruen);\n  border-radius: 8px;\n  padding: 10px 12px;\n}\n\n.mitglied-name {\n  flex: 1;\n  font-size: 1em;\n  color: var(--dunkelgruen);\n  text-align: left;\n}\n\n.mitglied-zelt {\n  font-size: 0.85em;\n  color: var(--placeholder);\n  font-family: 'Circular', sans-serif;\n  white-space: nowrap;\n}\n\n/* Entfernen-Button — kompakt, gegen globale Button-Regeln abgesichert */\n.btn-remove {\n  background-color: transparent;\n  color: var(--blutorange);\n  border: none;\n  padding: 4px;\n  width: auto;\n  min-height: auto;\n  margin-top: 0;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.btn-remove .material-symbols-outlined {\n  font-size: 1.2em;\n  color: var(--blutorange);\n}\n\n.btn-remove:hover {\n  opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
